import React from 'react';

const NameCell = ({data, ...rest}) => {
    const value = `${data.ownerFirstName} ${data.ownerLastName}`;

    return (
        <span {...rest}>
            {value}
        </span>
    );
};

export default NameCell;